export const routes = {
  editDepositLimit: '/account/deposit-limits',
}
